import type { Circuit, PlayerTrackPosition } from '../types/track.js';
import { normalizeMainPathIndex } from './jokerLap.js';
import { hasStartFinishCellOverlap } from './circuitLoop.js';

function isMainPathOnly(position: PlayerTrackPosition): boolean {
  return position.jokerBranchIndex == null && position.startLaneIndex == null;
}

/**
 * Pas logique de fermeture de boucle sur la case S/F : pathLen-1 → 0
 * (tuile monde partagée, cases d’occupation distinctes).
 */
export function isStartFinishLogicalWrap(
  circuit: Circuit,
  from: PlayerTrackPosition,
  to: PlayerTrackPosition
): boolean {
  if (!hasStartFinishCellOverlap(circuit)) return false;
  if (!isMainPathOnly(from) || !isMainPathOnly(to)) return false;
  const pathLen = circuit.path.length;
  const fromIdx = normalizeMainPathIndex(from.mainPathIndex, pathLen);
  const toIdx = normalizeMainPathIndex(to.mainPathIndex, pathLen);
  return fromIdx === pathLen - 1 && toIdx === 0;
}

/**
 * Indices path opposés de la ligne S/F (0 vs pathLen-1). Conservé pour le
 * sens du wrap / classement ; l’occupation collision utilise déjà des clés distinctes.
 */
export function isStartFinishOppositeSidePair(
  circuit: Circuit,
  a: PlayerTrackPosition,
  b: PlayerTrackPosition
): boolean {
  if (!hasStartFinishCellOverlap(circuit)) return false;
  if (!isMainPathOnly(a) || !isMainPathOnly(b)) return false;
  const pathLen = circuit.path.length;
  const ia = normalizeMainPathIndex(a.mainPathIndex, pathLen);
  const ib = normalizeMainPathIndex(b.mainPathIndex, pathLen);
  return (ia === 0 && ib === pathLen - 1) || (ia === pathLen - 1 && ib === 0);
}

/** Occupant encore côté arrivée (pathLen-1) sur la boucle S/F. */
export function isStartFinishFinishSide(circuit: Circuit, position: PlayerTrackPosition): boolean {
  if (!hasStartFinishCellOverlap(circuit)) return false;
  if (!isMainPathOnly(position)) return false;
  const pathLen = circuit.path.length;
  return normalizeMainPathIndex(position.mainPathIndex, pathLen) === pathLen - 1;
}
